import { render, staticRenderFns } from "./OFileInput.vue?vue&type=template&id=28a486e7&scoped=true&"
import script from "./OFileInput.vue?vue&type=script&lang=js&"
export * from "./OFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a486e7",
  null
  
)

export default component.exports